import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Title.svg'


const _withScopeId = n => (_pushScopeId("data-v-3a64c232"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Continue last game", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Collapse as Move", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Collapsing a piece or color is your move!", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Single Collapse", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "You may perform a single collapse before making your move.", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "All Quantum", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Allows all quantum moves and arbitrarily many collapses.", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Show game explanation", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "About", -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GameExplanation = _resolveComponent("GameExplanation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createVNode(_Transition, {
        name: "fade",
        appear: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _imports_0,
            width: "577",
            height: "202",
            alt: "q4 Logo",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('backGame'))),
            style: _normalizeStyle({ cursor: _ctx.mayContinue ? 'pointer' : undefined })
          }, null, 4)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("main", null, [
      (_ctx.mayContinue)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('backGame'))),
            class: "resumeButton"
          }, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startGame(true, Infinity)))
      }, _hoisted_5),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.startGame(false, 1)))
      }, _hoisted_8),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.startGame(false, Infinity)))
      }, _hoisted_11),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$refs.expl.open()))
        }, _hoisted_13),
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$refs.expl.open('about')))
        }, _hoisted_15)
      ])
    ]),
    _createVNode(_component_GameExplanation, { ref: "expl" }, null, 512)
  ], 64))
}